import cx from 'classnames'
import { LegendPill } from '@/features/legends/components/LegendPill'
import { type RynoType, Types } from '@/features/legends/editor/ryno-types'
import { DEFAULT, match } from '@/utils/pattern-match-util'
import styles from './TypeBadge.module.css'

export interface TypeBadgeProps {
  type: RynoType | null | undefined
}

/**
 * A value type, colored by kind. A list shows its element type inside.
 */
export function TypeBadge({ type }: TypeBadgeProps) {
  if (!type) {
    return null
  }
  if (Types.isListType(type)) {
    return (
      <LegendPill className={cx(styles.root, styles.list)}>
        List
        <TypeBadge type={type.elementType} />
      </LegendPill>
    )
  }
  const name = Types.getFriendlyTypeName(type)
  return (
    <LegendPill
      className={cx(
        styles.root,
        match(name, {
          String: styles.string,
          Number: styles.number,
          Boolean: styles.boolean,
          Date: styles.date,
          [DEFAULT]: styles.other,
        }),
      )}
    >
      {name}
    </LegendPill>
  )
}
